export default __webpack_public_path__ + "static/media/pause.720926bb.svg";